/* The visitor's measurement system (imperial / metric) in the browser: the saved preference, else imperial in the countries
   that use it and metric elsewhere. It decides the units a height, weight or distance is asked for and shown in (ft/in or
   m/cm, lb or kg, mi or km). The same rule as TmMeasurement::getEffectiveUnit (app/shared/TmMeasurement.php): keep
   imperialCountries in step with its IMPERIAL_COUNTRIES. The preference lives in tmv-measurement (tmVisitorStore); an
   account's saved one (tm_measurement) is applied to it by tmAuth.applyMeasurementPreference, and setPreference saves a
   signed-in visitor's pick as the account's (tm_measurement_changed -> tmAuth.saveSitePreference) */
window.tmMeasurement = function () {
    const imperialCountries = ['US', 'PR', 'GU', 'VI', 'AS', 'MP', 'UM', 'LR', 'MM'];

    function canonical(unit) {
        unit = String(unit || '').trim().toLowerCase();
        return unit === 'imperial' || unit === 'metric' ? unit : '';
    }

    return {
        /* 'imperial' or 'metric' as saved; '' when none is (No preference) */
        getPreference: function () {
            return canonical(tmVisitorStore.getMeasurement());
        },

        /* saves 'imperial' or 'metric'; anything else ('') clears the visitor's tmv-measurement cookie only: a signed-in
           account's system is not cleared (tm_save_site_preference refuses ''), its No preference is saved on Account settings */
        setPreference: function (unit) {
            unit = canonical(unit);
            tmVisitorStore.setMeasurement(unit);
            jQuery(document).trigger('tm_measurement_changed', { unit: unit });
        },

        /* the system to use: the preference, else by country (ISO 3166-1 alpha-2, any case; default the tmv-country
           cookie, tmVisitorStore.getCountry). An unknown country is metric, as in PHP. For a first visit with no
           tmv-country yet: tmVisitorStore.resolveCountry().then(tmMeasurement.getEffectiveUnit) */
        getEffectiveUnit: function (country) {
            const preference = tmMeasurement.getPreference();
            if (preference !== '') {
                return preference;
            }
            if (typeof country !== 'string') {
                country = tmVisitorStore.getCountry();
            }
            return imperialCountries.indexOf(country.trim().toUpperCase()) !== -1 ? 'imperial' : 'metric';
        }
    };
}();
